import { render, staticRenderFns } from "./skill_target.vue?vue&type=template&id=17bf2944&"
import script from "./skill_target.vue?vue&type=script&lang=js&"
export * from "./skill_target.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports